




















/* General */
import Vue from 'vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */

/* Helpers */
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'ItemCreateTopbar',

  components: {
    MainContainer,
  },

  props: {
    entityId: {
      type: Number,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },

  data() {
    return {
      EEntities,
      TextAssistant,
      BreadcrumbAssistant,
      scrolledPastTitle: false,
    }
  },

  computed: {
    arrowClasses(): string {
      if (this.$screen.isTabletOrDesktop(this.$mq)) {
        return 'ddi ddi-caret-right'
      }
      return 'hidden'
    },
  },

  mounted() {
    document.addEventListener('scroll', this.checkScrollPosition)
  },

  beforeDestroy() {
    document.removeEventListener('scroll', this.checkScrollPosition)
  },

  methods: {
    checkScrollPosition() {
      // Low-fi estimated height where the title is scrolled up.
      // Didn't want to get too sophisticated here.
      this.scrolledPastTitle = window.scrollY > 200
    },
  },
})
